import {
  ADDTRAVELDETAILS,
  ADDTRAVELNUMBER,
  ALLTRAVELDETAILS,
  TRAVELNUMFLAG,
} from "../actiontypes/NumTravelActiontypes ";

const init = {
  istravelno: false,
  travelnum: "",
  travelDestination: "",
  noOfpeoples: "",
  travelDate: "",
  medical: "",
  contact: "",
  isalltraveldetails: false,
};
export const numTravelReducer = (state = init, { type, payload }) => {
  switch (type) {
    case ADDTRAVELNUMBER:
      return { ...state, travelnum: payload, istravelno: true };
    case TRAVELNUMFLAG:
      return { ...state, travelnum: "", istravelno: false };
    case ADDTRAVELDETAILS:
      return {
        ...state,
        travelDestination: payload.Destination,
        noOfpeoples: payload.noOfTravellers,
        travelDate: payload.startAndEndDate,
        medical: payload.MedicalCondition,
        contact: payload.phonenumber,
        isalltraveldetails: true,
      };
    case ALLTRAVELDETAILS:
      return { ...state, isalltraveldetails: true };
    default:
      return { ...state };
  }
};
